import { PropsWithChildren, ReactElement, useRef, useCallback } from 'react';
import { SnackbarProvider, SnackbarKey } from 'notistack';
import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const CustomSnackbarProvider = ({
  children,
}: PropsWithChildren): ReactElement => {
  const notistackRef = useRef<SnackbarProvider>(null);

  const onClickDismiss = useCallback(
    (key: SnackbarKey) => () => {
      notistackRef.current?.closeSnackbar(key);
    },
    [],
  );

  const actionClose = useCallback(
    (key: SnackbarKey) => (
      <IconButton
        aria-label="Close"
        onClick={onClickDismiss(key)}
        color="inherit"
      >
        <CloseIcon />
      </IconButton>
    ),
    [onClickDismiss],
  );

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={8}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      action={actionClose}
    >
      {children}
    </SnackbarProvider>
  );
};

export default CustomSnackbarProvider;
